import dayjs from 'dayjs'
import { SelectOption } from '@Components/Selectors/Select'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { DropdownDiscriminatedProps } from '@App/forms/common/dropdown-form-field'

const DEFAULT_START_MONTH = '2021-01'

type UsagePeriodFilter = DropdownDiscriminatedProps & { name: 'usagePeriod' }

const createUsagePeriodMonthOptions = () => {
    const options: SelectOption[] = []
    let currentMonth = dayjs(DEFAULT_START_MONTH)
    const lastMonth = dayjs().startOf('month')

    while (currentMonth.isSame(lastMonth, 'month') || currentMonth.isBefore(lastMonth, 'month')) {
        const value = currentMonth.format('YYYY-MM')
        options.push({ id: value, value, label: currentMonth.format('MMMM YYYY') })
        currentMonth = currentMonth.add(1, 'month')
    }

    return options
}

export const createUsagePeriodFilter = (): UsagePeriodFilter => ({
    type: FormFieldTypes.DROPDOWN,
    name: 'usagePeriod',
    label: 'Select Month',
    placeholder: 'Select Month',
    options: createUsagePeriodMonthOptions(),
    isClearable: true,
})
